import { useLocation } from 'react-router-dom';
import Nav from './MainNavigation/Nav';
import ParticlesBackground from '../UI/ParticlesBackground'

const Layout = () => {
  const { pathname } = useLocation();

  const hideNav = ['/my-resume'].includes(pathname);

  return (
    <div id="layout" className="-z-10">
      {!hideNav && <Nav />}
      <div className="hidden text-[.95rem] lg:block lg:blocktext-sm fixed bottom-36 -right-16 rotate-90 text-lightMode-paragraph hover:text-lightMode-100 dark:text-darkMode-100 dark:hover:text-darkMode-400 tracking-wide z-40">
        {!hideNav && (
          <a
            href="mailto:babsman4all@gmail.com"
            target="_blank"
            rel="noopener noreferrer">
            babsman4all@gmail.com
          </a>
        )}
      </div>
      {pathname === '/' && <ParticlesBackground />}
    </div>
  );
};

export default Layout;
